angular.module('NiacsProjectApp.controllers-homework', [
])
.controller('HomeworkCtrl',['$scope','$routeParams','$location','ProjectService','CourseOfferingService','MenuService',
    function($scope,$routeParams,$location,ProjectService,CourseOfferingService,MenuService) {
        ProjectService.get($routeParams,'HomeworkCtrl',function(project){
            CourseOfferingService.getForProject($scope.project = project).then(function(course) {
                var homework = course.getHomework($routeParams.hwId);
                if(homework) {
                    if(!project.training.homework || angular.isArray(project.training.homework)) {
                        project.training.homework = {};
                    }
                    if(!project.training.homework[homework.id] || angular.isArray(project.training.homework[homework.id])) {
                        project.training.homework[homework.id] = {};
                    }
                    $scope.course = course;
                    $scope.homework = homework;
                    MenuService.getStepInfo($location).then(function(stepInfo){
                        // special case the stepName for the "final" homework
                        var isFinal = false;
                        if(stepInfo.stepName === 'Step 5' && course.homework[stepInfo.stepName]) {
                            var hws = course.homework[stepInfo.stepName],
                                last = hws[hws.length-1];
                            isFinal = stepInfo.active.label === last.title;
                        }
                        $scope.stepName = isFinal ? 'the Course' : stepInfo.stepName;
                    });
                }
            });
        });
}])
.directive('hwQualAnswers',['ProjectService','AutoSaveService',function(ProjectService,AutoSaveService) {
    return {
        restrict: 'E',
        templateUrl: 'partials/lms/hw-qual-answers.html',
        scope: {
            homeworkQual: '=',
            homeworkAnswers: '='
        },
        link: function($scope,$element,$attrs) {
            $scope.isSaving = function(id) {
                if($scope.changedId === id) {
                    return false; // don't "disable" the checkbox that was clicked since it's odd.
                }
                return AutoSaveService.isSaving();
            };
            // getting the labels/values widths to align will
            // be a pain with CSS so just do it programmatically
            function resize() {
                var labels = $element.find('.rangeLabel'),
                    values = $element.find('.rangeValue'),
                    maxW = 0;
                labels.each(function(){
                    var w = $(this).width();
                    if(w > maxW) {
                        maxW = w;
                    }
                });
                function setW() {
                    $(this).css('width',maxW);
                }
                labels.each(setW);
                values.each(setW);
            }
            $scope.$watch('homeworkQual',function(){
                if($scope.homeworkQual) {
                    var qual = $scope.homeworkQual,
                        range = [],i;
                    for(i = qual.from.v; i <= qual.to.v; i++) {
                        range.push(i);
                    }
                    $scope.qualRange = range;
                    setTimeout(resize,500);
                }
            });
            $scope.onChange = function(id){
                $scope.changedId = id;
                ProjectService.save().then(function(){ delete $scope.changedId; });
            };
        }
    };
}])
.directive('hwTextAnswer',['AutoSaveService','ProjectService',function(AutoSaveService,ProjectService){
    return {
        restrict: 'E',
        templateUrl: 'partials/lms/hw-text-answer.html',
        scope: {
            question: '=',
            answerType: '@',
            homeworkAnswers: '='
        },
        link: function($scope) {
            $scope.answer = {};
            function init() {
                if($scope.question && $scope.homeworkAnswers) {
                    $scope.answer.text = $scope.homeworkAnswers[$scope.question.id];
                    AutoSaveService.setup($scope.answer,function(){
                        $scope.homeworkAnswers[$scope.question.id] = $scope.answer.text;
                        ProjectService.save();
                    });
                }
            }
            $scope.$watch('question',init);
            $scope.$watch('homeworkAnswers',init);
        }
    };
}]);